<template>
  <div class="app-bar-icon">
    <nuxt-link to="/">
      <v-avatar color="grey lighten-5" size="56">
        <v-img contain :src="'customers/' + customer + '/logo-dashboard.png'" />
      </v-avatar>
    </nuxt-link>
  </div>
</template>

<script>
export default {
  data({ $config }) {
    return {
      customer: $config.CUSTOMER,
    };
  },
};
</script>

<style lang="scss" scoped>
.app-bar-icon {
  height: 100%;
  width: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
